var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.reappraise && !_vm.isPostExam
      ? _c(
          "div",
          [
            _vm.fromProponent ||
            _vm.fromAcademicDirector ||
            _vm.fromBoard ||
            _vm.fromConsultant ||
            _vm.fromConsultantOverdue ||
            _vm.fromAcademicDirector2
              ? _c(
                  "el-form-item",
                  { attrs: { label: "Απόφαση Προέδρου" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        on: { change: _vm.togglePresidentDecision },
                        model: {
                          value: _vm.presidentJudgement.decision_type,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.presidentJudgement,
                              "decision_type",
                              $$v
                            )
                          },
                          expression: "presidentJudgement.decision_type"
                        }
                      },
                      [
                        !_vm.fromConsultantOverdue
                          ? _c("el-radio", {
                              attrs: { label: "Συμφωνία", border: "" }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.fromAcademicDirector2 && !_vm.fromConsultant2
                          ? _c("el-radio", {
                              attrs: {
                                label: "Παραπομπή σε Αξιολογητή",
                                border: ""
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.fromBoard
                          ? _c("el-radio", {
                              attrs: {
                                label:
                                  "Μη Ομοφωνία Εκτελεστικής Επιτροπής/Παραπομπή σε Τμήμα",
                                border: ""
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.fromConsultantOverdue
              ? _c(
                  "el-form-item",
                  [
                    _c("el-alert", {
                      attrs: {
                        type: "info",
                        title:
                          "Πρόκειται για αίτηση που επιστρέφει μετά από την παρέλευση 15ήμερου χωρίς υποβολή εισήγησης αξιολογητή.",
                        "show-icon": ""
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            this.presidentJudgement.decision_type === "Συμφωνία" || _vm.fromVice
              ? _c(
                  "el-form-item",
                  { attrs: { label: "Επιλογή Απόφασης" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "bigger",
                        attrs: {
                          filterable: "",
                          placeholder: "Παρακαλώ Επιλέξτε"
                        },
                        on: { change: _vm.toggleFinalDecision },
                        model: {
                          value: _vm.presidentJudgement.decision,
                          callback: function($$v) {
                            _vm.$set(_vm.presidentJudgement, "decision", $$v)
                          },
                          expression: "presidentJudgement.decision"
                        }
                      },
                      _vm._l(_vm.validatedFinalDecisions, function(
                        finalDecision
                      ) {
                        return _c("el-option", {
                          key: finalDecision.id,
                          attrs: {
                            label: finalDecision.decision_text,
                            value: finalDecision.id,
                            filterable: ""
                          }
                        })
                      })
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showCorespWith
              ? _c(
                  "el-form-item",
                  { attrs: { label: "Με" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "bigger",
                        attrs: {
                          filterable: "",
                          placeholder: "Παρακαλώ Επιλέξτε"
                        },
                        on: { change: _vm.toggleTitlesCorrespondence },
                        model: {
                          value: _vm.presidentJudgement.departmentName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.presidentJudgement,
                              "departmentName",
                              $$v
                            )
                          },
                          expression: "presidentJudgement.departmentName"
                        }
                      },
                      [
                        _c("el-option", {
                          key: _vm.titlesCorrespondence.universityDepartment.id,
                          attrs: {
                            value:
                              _vm.titlesCorrespondence.universityDepartment
                                .name,
                            label:
                              _vm.titlesCorrespondence.universityDepartment.name
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.presidentJudgement.decision_type ===
            "Μη Ομοφωνία Εκτελεστικής Επιτροπής/Παραπομπή σε Τμήμα"
              ? _c(
                  "el-form-item",
                  { attrs: { label: "Ανάθεση σε Αντιπρόεδρο" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "Παρακαλώ Επιλέξτε" },
                        model: {
                          value: _vm.assignedToVicePresident,
                          callback: function($$v) {
                            _vm.assignedToVicePresident = $$v
                          },
                          expression: "assignedToVicePresident"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            label: "Αντιπρόεδρος Α",
                            value: "VicePresidentA"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: {
                            label: "Αντιπρόεδρος Β",
                            value: "VicePresidentB"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.reappraise
      ? _c(
          "div",
          [
            _c(
              "el-form-item",
              { attrs: { label: "Απόφαση Προέδρου" } },
              [
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.changeReappDecisionType },
                    model: {
                      value: _vm.presidentJudgement.reappraisalDecisionType,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.presidentJudgement,
                          "reappraisalDecisionType",
                          $$v
                        )
                      },
                      expression: "presidentJudgement.reappraisalDecisionType"
                    }
                  },
                  [
                    _c("el-radio", {
                      attrs: { label: "Πλήρης Ικανοποίηση", border: "" }
                    }),
                    _vm._v(" "),
                    _vm.reappDegreeType === "bachelor" && !_vm.fromBoard
                      ? _c("el-radio", {
                          attrs: { label: "Μερική Ικανοποίηση", border: "" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.fromAcademicDirectorReappraisal ||
                    this.isSecondReappraisal
                      ? _c("el-radio", {
                          attrs: {
                            label: "Εμμονή Στην Προηγούμενη Πράξη Αναγνώρισης",
                            border: ""
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            ![null, "Εμμονή Στην Προηγούμενη Πράξη Αναγνώρισης"].includes(
              this.presidentJudgement.reappraisalDecisionType
            )
              ? _c(
                  "el-form-item",
                  { attrs: { label: "Επιλογή Απόφασης" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "700px" },
                        attrs: {
                          filterable: "",
                          placeholder: "Παρακαλώ Επιλέξτε"
                        },
                        on: { change: _vm.changeReappDecision },
                        model: {
                          value: _vm.presidentJudgement.decision,
                          callback: function($$v) {
                            _vm.$set(_vm.presidentJudgement, "decision", $$v)
                          },
                          expression: "presidentJudgement.decision"
                        }
                      },
                      _vm._l(_vm.validatedReappDecisions, function(
                        reappDecision
                      ) {
                        return _c("el-option", {
                          key: reappDecision.id,
                          attrs: {
                            label: reappDecision.decision_text,
                            value: reappDecision.id,
                            filterable: ""
                          }
                        })
                      })
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showCorespWith
              ? _c(
                  "el-form-item",
                  { attrs: { label: "Με" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "bigger",
                        attrs: {
                          filterable: "",
                          placeholder: "Παρακαλώ Επιλέξτε"
                        },
                        on: { change: _vm.toggleTitlesCorrespondence },
                        model: {
                          value: _vm.presidentJudgement.departmentName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.presidentJudgement,
                              "departmentName",
                              $$v
                            )
                          },
                          expression: "presidentJudgement.departmentName"
                        }
                      },
                      _vm._l(_vm.titlesCorrespondence, function(item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: {
                            label: item.name,
                            value: item.name,
                            filterable: ""
                          }
                        })
                      })
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isPostExam
      ? _c(
          "div",
          [
            _c(
              "el-form-item",
              { attrs: { label: "Απόφαση Προέδρου" } },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.presidentJudgement.decision_type,
                      callback: function($$v) {
                        _vm.$set(_vm.presidentJudgement, "decision_type", $$v)
                      },
                      expression: "presidentJudgement.decision_type"
                    }
                  },
                  [
                    _c("el-radio", { attrs: { label: "Συμφωνία", border: "" } })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            this.presidentJudgement.decision_type === "Συμφωνία"
              ? _c(
                  "el-form-item",
                  { attrs: { label: "Επιλογή Απόφασης" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "bigger",
                        attrs: {
                          filterable: "",
                          placeholder: "Παρακαλώ Επιλέξτε"
                        },
                        on: { change: _vm.toggleFinalDecision },
                        model: {
                          value: _vm.presidentJudgement.decision,
                          callback: function($$v) {
                            _vm.$set(_vm.presidentJudgement, "decision", $$v)
                          },
                          expression: "presidentJudgement.decision"
                        }
                      },
                      _vm._l(_vm.validatedFinalDecisions, function(
                        finalDecision
                      ) {
                        return _c("el-option", {
                          key: finalDecision.id,
                          attrs: {
                            label: finalDecision.decision_text,
                            value: finalDecision.id,
                            filterable: ""
                          }
                        })
                      })
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showCorespWith
              ? _c(
                  "el-form-item",
                  { attrs: { label: "Με" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "bigger",
                        attrs: {
                          filterable: "",
                          placeholder: "Παρακαλώ Επιλέξτε"
                        },
                        on: { change: _vm.toggleTitlesCorrespondence },
                        model: {
                          value: _vm.presidentJudgement.departmentName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.presidentJudgement,
                              "departmentName",
                              $$v
                            )
                          },
                          expression: "presidentJudgement.departmentName"
                        }
                      },
                      [
                        _c("el-option", {
                          key: _vm.titlesCorrespondence.universityDepartment.id,
                          attrs: {
                            value:
                              _vm.titlesCorrespondence.universityDepartment
                                .name,
                            label:
                              _vm.titlesCorrespondence.universityDepartment.name
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f59c278", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f59c278","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/PresidentDecision.vue
// module id = null
// module chunks = 